// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
    display: flex;                /* Ensure it's a flex container */
    flex-direction: column;       /* Stack children vertically */
    flex: 1 1;
    background-color: #F8F8F8;    /* Full screen background color */
    justify-content: center;      /* Center content vertically */
    align-items: center;          /* Center content horizontally */
    padding: 16px; 
    font-family: 'GT-Walsheim'   
  }
  
  .scrollContainer {
    flex-grow: 1;
    align-items: center;          /* Center content horizontally */
    justify-content: center;      /* Center content vertically inside the scroll */
    width: 100%;     
    font-family: 'GT-Walsheim'   
    /* Ensure full width */
  }
  .scrollable-container {
    max-height: 70vh; /* or whatever height you prefer */
    overflow-y: auto;
    padding: 20px;
    font-family: 'GT-Walsheim'   

  }
  .scrollable-container::-webkit-scrollbar {
    display: none;
    font-family: 'GT-Walsheim'   

  }
  
  /* Optional: Ensure the container can still be scrolled */
  .scrollable-container {
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;     /* Firefox */
  }
  
  .content {
    width: 100%;
    padding-bottom: 20px;         /* Prevents content from being cut off at the bottom */
    justify-content: center;      /* Centers content inside the scroll view */
    align-items: center;  
    font-family: 'GT-Walsheim'   
    /* Ensures all children are centered horizontally */
  }
  
  .header-container {
    display: flex;                /* Use flex to align items horizontally */
    flex-direction: row;          /* Align items in a row */
    justify-content: center; 
    align-items: center;     /* Centers the header content horizontally */
    margin-bottom: 25px;          /* Adds space below the heading */
    width: 100%;  
    color: #101925;
    font-size: 22px;
    line-height: 28.8px;
    font-weight: 700;   
    font-family: 'GT-Walsheim'   
    /* Ensures full width for header alignment */
  }
  
  .header-icon {
    width: 40px;                  /* Increase icon size */
    height: 40px;                 /* Increase icon size */
    margin-right: 5px;           /* Adds some space between icon and text */
  }
  
  .headerText {
    font-size: 50px;
    font-weight: 700;
    color: #000;
    letter-spacing: 0.5px;
    text-align: center; 
    font-family: 'GT-Walsheim'   
    /* Ensure text is centered */
  }
  
  .login-button {
   
    background-color: #0A1829 !important;
    justify-content: center;
    align-items: center;
    align-self: center;  
    background: #0b1422;
    color: white;
    border-radius: 8px;
    width: 100%;
    border: none;
    margin-top: 16px;
    font-family: 'GT-Walsheim'  ;
    font-size: 14px;
    font-weight: 700;
    width: 328px;
    height: 40px;
    padding: 10px 20px 10px 20px;
  }         /* Ensures the button is horizontally centered */
  
  
  .loginButtonText {
    color: #fff;
    font-size: 14px;
    font-weight: 600;
    font-family: 'GT-Walsheim'   

  }

  .loader-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    font-family: 'GT-Walsheim'   

  }
  .error-message {
    color: red;
    font-size: 15px;
    margin-top: 10px;
    font-family: 'GT-Walsheim'   

  }
  
  
  `, "",{"version":3,"sources":["webpack://./src/Screens/FranchiseeProfile.css"],"names":[],"mappings":"AAAA;IACI,aAAa,iBAAiB,iCAAiC;IAC/D,sBAAsB,QAAQ,8BAA8B;IAC5D,SAAO;IACP,yBAAyB,KAAK,iCAAiC;IAC/D,uBAAuB,OAAO,8BAA8B;IAC5D,mBAAmB,WAAW,gCAAgC;IAC9D,aAAa;IACb;EACF;;EAEA;IACE,YAAY;IACZ,mBAAmB,WAAW,gCAAgC;IAC9D,uBAAuB,OAAO,gDAAgD;IAC9E,WAAW;IACX,yBAAyB;IACzB,sBAAsB;EACxB;EACA;IACE,gBAAgB,EAAE,kCAAkC;IACpD,gBAAgB;IAChB,aAAa;IACb;;EAEF;EACA;IACE,aAAa;IACb;;EAEF;;EAEA,yDAAyD;EACzD;IACE,wBAAwB,GAAG,gBAAgB;IAC3C,qBAAqB,MAAM,YAAY;EACzC;;EAEA;IACE,WAAW;IACX,oBAAoB,UAAU,sDAAsD;IACpF,uBAAuB,OAAO,2CAA2C;IACzE,mBAAmB;IACnB,yBAAyB;IACzB,mDAAmD;EACrD;;EAEA;IACE,aAAa,iBAAiB,yCAAyC;IACvE,mBAAmB,WAAW,yBAAyB;IACvD,uBAAuB;IACvB,mBAAmB,MAAM,4CAA4C;IACrE,mBAAmB,WAAW,iCAAiC;IAC/D,WAAW;IACX,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;IACzB,4CAA4C;EAC9C;;EAEA;IACE,WAAW,mBAAmB,uBAAuB;IACrD,YAAY,kBAAkB,uBAAuB;IACrD,iBAAiB,YAAY,0CAA0C;EACzE;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,qBAAqB;IACrB,kBAAkB;IAClB,yBAAyB;IACzB,4BAA4B;EAC9B;;EAEA;;IAEE,oCAAoC;IAEpC,uBAAuB;IACvB,mBAAmB;IAEnB,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,4BAA4B;IAC5B,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,4BAA4B;EAC9B,UAAU,gDAAgD;;;EAG1D;IACE,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB;;EAEF;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb;;EAEF;EACA;IACE,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB;;EAEF","sourcesContent":[".container {\n    display: flex;                /* Ensure it's a flex container */\n    flex-direction: column;       /* Stack children vertically */\n    flex: 1;\n    background-color: #F8F8F8;    /* Full screen background color */\n    justify-content: center;      /* Center content vertically */\n    align-items: center;          /* Center content horizontally */\n    padding: 16px; \n    font-family: 'GT-Walsheim'   \n  }\n  \n  .scrollContainer {\n    flex-grow: 1;\n    align-items: center;          /* Center content horizontally */\n    justify-content: center;      /* Center content vertically inside the scroll */\n    width: 100%;     \n    font-family: 'GT-Walsheim'   \n    /* Ensure full width */\n  }\n  .scrollable-container {\n    max-height: 70vh; /* or whatever height you prefer */\n    overflow-y: auto;\n    padding: 20px;\n    font-family: 'GT-Walsheim'   \n\n  }\n  .scrollable-container::-webkit-scrollbar {\n    display: none;\n    font-family: 'GT-Walsheim'   \n\n  }\n  \n  /* Optional: Ensure the container can still be scrolled */\n  .scrollable-container {\n    -ms-overflow-style: none;  /* IE and Edge */\n    scrollbar-width: none;     /* Firefox */\n  }\n  \n  .content {\n    width: 100%;\n    padding-bottom: 20px;         /* Prevents content from being cut off at the bottom */\n    justify-content: center;      /* Centers content inside the scroll view */\n    align-items: center;  \n    font-family: 'GT-Walsheim'   \n    /* Ensures all children are centered horizontally */\n  }\n  \n  .header-container {\n    display: flex;                /* Use flex to align items horizontally */\n    flex-direction: row;          /* Align items in a row */\n    justify-content: center; \n    align-items: center;     /* Centers the header content horizontally */\n    margin-bottom: 25px;          /* Adds space below the heading */\n    width: 100%;  \n    color: #101925;\n    font-size: 22px;\n    line-height: 28.8px;\n    font-weight: 700;   \n    font-family: 'GT-Walsheim'   \n    /* Ensures full width for header alignment */\n  }\n  \n  .header-icon {\n    width: 40px;                  /* Increase icon size */\n    height: 40px;                 /* Increase icon size */\n    margin-right: 5px;           /* Adds some space between icon and text */\n  }\n  \n  .headerText {\n    font-size: 50px;\n    font-weight: 700;\n    color: #000;\n    letter-spacing: 0.5px;\n    text-align: center; \n    font-family: 'GT-Walsheim'   \n    /* Ensure text is centered */\n  }\n  \n  .login-button {\n   \n    background-color: #0A1829 !important;\n    border-radius: 4px;\n    justify-content: center;\n    align-items: center;\n    margin-top: 24px;\n    align-self: center;  \n    background: #0b1422;\n    color: white;\n    border-radius: 8px;\n    width: 100%;\n    border: none;\n    margin-top: 16px;\n    font-family: 'GT-Walsheim'  ;\n    font-size: 14px;\n    font-weight: 700;\n    width: 328px;\n    height: 40px;\n    padding: 10px 20px 10px 20px;\n  }         /* Ensures the button is horizontally centered */\n  \n  \n  .loginButtonText {\n    color: #fff;\n    font-size: 14px;\n    font-weight: 600;\n    font-family: 'GT-Walsheim'   \n\n  }\n\n  .loader-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100vh;\n    font-family: 'GT-Walsheim'   \n\n  }\n  .error-message {\n    color: red;\n    font-size: 15px;\n    margin-top: 10px;\n    font-family: 'GT-Walsheim'   \n\n  }\n  \n  \n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
